import './mask-field-date.scss'

import { PropType } from "vue"
import Component from 'vue-class-component'
import _ from 'lodash';

import { EntityField, EntityFieldStatus, SkinDate } from '@skinsoft/types';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { DATE_FORMATS as AVAILABLE_DATE_FORMATS, buildSkinDateWithFormat, skinDateToInputDate } from '@skinsoft/utils';

declare const config
const DATE_FORMATS: string = config.date_formats

@Component({
    components: {

    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
        },
        fieldValue: {},
        editing: {
            type: Boolean,
        },
        getStatus: {},
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-date.html')
})
export class MaskFieldDate extends ReactiveVue {
    private entityField: EntityField
    private fieldValue: any
    private editing: Boolean
    private dataCy: String
    private getStatus: (entityField: EntityField) => EntityFieldStatus

    private get value(): String | null {
        let res: string | null

        if (this.fieldValue) {
            const txtValue = (this.fieldValue?.txt) as string

            if(txtValue) {
                res = txtValue.split('/').reverse().join('-')
            } else {
                res = skinDateToInputDate(this.fieldValue)
            }
        } else {
            res = null;
        }

        return res
    }

    private set value(input: String | null) {
        let returnValue: SkinDate | null

        if (input) {
            const reshapedDateTxt = input.split('-').reverse().join('/')
            returnValue = buildSkinDateWithFormat(
                reshapedDateTxt, 
                AVAILABLE_DATE_FORMATS.DD_MM_YYYY_SLASH
            )
        } else {
            returnValue = null
        }

        this.$emit("value-change", {
            abstractEntity: this.entityField.abstractEntity,
            fieldPath: this.entityField.path,
            value: returnValue,
        })
    }

    private getDateFormatOptions() {
        // for the moment, the 'locale' prop of BDatePicker override the order of the different fields (mm,DD,yyyy)
        switch(DATE_FORMATS) {
            case AVAILABLE_DATE_FORMATS.DD_MM_YYYY_SLASH:
                return {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }
            case AVAILABLE_DATE_FORMATS.MM_DD_YYYY_SLASH:
                return {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                }
            case AVAILABLE_DATE_FORMATS.YYYY_MM_DD_SLASH: 
                return {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                }
            case AVAILABLE_DATE_FORMATS.DD_MM_YYYY_DASH:
                return {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }
            case AVAILABLE_DATE_FORMATS.MM_DD_YYYY_DASH:
                return {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                }
            case AVAILABLE_DATE_FORMATS.YYYY_MM_DD_DASH: 
                return {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                }
            default: 
                return {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }
        }
    }

    private isReadonly(entityField: EntityField) {
        return entityField.isReadOnly || this.getStatus(entityField).disabled
    }

    private infoMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).disabledMessage
    }

    private errorMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).errorMessage
    }

    private hasError(entityField: EntityField) {
        return this.getStatus(entityField).error
    }
}